import { isUserStorageMount } from '../storageFileAudit/formatters';

/** Presence/edit-locks are for shared mounts only — My Storage is owner-only. */
export function isDocumentPresenceEnabled(options: {
  mountId: string | null | undefined;
  embeddedInPopup?: boolean;
}): boolean {
  if (options.embeddedInPopup) return false;
  return !isUserStorageMount(options.mountId);
}

/**
 * "View only" means annotation/discussion read-only on a mount that has discussions.
 * Disabled discussions (Public / My Storage) must not imply the document itself is read-only.
 */
export function shouldShowDocumentViewOnlyBadge(options: {
  discussionsEnabled: boolean;
  annotateReadOnly: boolean;
  hasReviewError: boolean;
}): boolean {
  return options.discussionsEnabled && options.annotateReadOnly && !options.hasReviewError;
}
